import React from 'react';
import PropTypes from 'prop-types';

import './Checkbox.css';

const Checkbox = ({ checkboxValue, checkboxName, checkboxStatus, onChange, checkboxId }) => {
  return (
    <div className="no-maxWidth">
      <div className="customCheck">
        <label htmlFor={checkboxId}>
          <input
            id={checkboxId}
            type="checkbox"
            value={checkboxValue}
            checked={checkboxStatus}
            onChange={(e) => onChange(e)}
            className="segurosCheckBox"
          />
          <span className="icon" />
          <p>
            {checkboxName}
          </p>
        </label>
      </div>
    </div>
  );
}

Checkbox.propTypes = {
  checkboxValue: PropTypes.bool,
  checkboxName: PropTypes.string,
  checkboxStatus: PropTypes.bool,
  onChange: PropTypes.func,
  checkboxId: PropTypes.string
};
Checkbox.defaultProps = { checkboxValue:'', checkboxName: '', checkboxStatus: '', onChange:  () => {}, checkboxId: '' };

export default Checkbox;